import { render, staticRenderFns } from "./LooxMessageLogs.vue?vue&type=template&id=81b681a6&scoped=true&"
import script from "./LooxMessageLogs.vue?vue&type=script&lang=js&"
export * from "./LooxMessageLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b681a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81b681a6')) {
      api.createRecord('81b681a6', component.options)
    } else {
      api.reload('81b681a6', component.options)
    }
    module.hot.accept("./LooxMessageLogs.vue?vue&type=template&id=81b681a6&scoped=true&", function () {
      api.rerender('81b681a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Integrations/loox/LooxMessageLogs.vue"
export default component.exports